import api from '@/api'

const namespaced = true

const state = {
  tonnages: [],
  tonnageFile: null
}

const getters = {
  tonnages: state => state.tonnages,
  tonnageFile: state => state.tonnageFile
}

const mutations = {
  SET_TONNAGES: (state, payload) => {
    state.tonnages = payload
  },
  SET_TONNAGE_FILE: (state, payload) => {
    state.tonnageFile = payload
  }
}

const actions = {
  async fetchTonnages({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const filter = {
        search: filterConfig.search,
        page: filterConfig.currentPage,
        limit: filterConfig.pageSize,
        ...payload
      }
      const { data } = await api.getTonnagePlans(filter)

      if (data.error) {
        commit('SET_TONNAGES', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }

      commit('SET_TONNAGES', data.data)
      commit('Table/SET_TOTAL_DATA', data.total, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
    } catch (err) {
      throw err
    }
  },
  async downloadTonnages({ commit }, payload) {
    try {
      const filter = { ...payload }
      const response = await api.downloadTonnagePlan(filter)

      if (response.data.error) {
        commit('SET_TONNAGE_FILE', null)
        return
      }

      commit('SET_TONNAGE_FILE', response)
    } catch (err) {
      throw err
    }
  },
  resetFile({ commit }) {
    commit('SET_TONNAGE_FILE', null)
  }
}

export default { namespaced, state, getters, mutations, actions }
